import {
  changeSwitchDurationService,
  createNewQuestionOptionService,
  createNewQuestionService,
  createNewSurveyPageService,
  createNewSurveyService,
  deleteQuestionService,
  deleteSurveyOptionService,
  deleteSurveyPageService,
  deleteSurveyService,
  duplicateQuestionService,
  duplicateSurveyService,
  getQuestionTypesService,
  getSurveyExcelService,
  getSurveyInfoService,
  getSurveyListService,
  getSurveyStatisticsService,
  pauseSurveyService,
  publishSurveyService,
  resumeSurveyService,
  saveFinishInfoService,
  saveImageSurveyService,
  saveInitialInfoService,
  saveSurveyDurationService,
  updateSurveyOptionService,
  updateSurveyQuestionService,
} from "../../../api/Surveys";
import { useState } from "react";
import handleMessages from "../../../utils/handleMessages";
import { useDispatch, useSelector } from "react-redux";
import { setSurveyInfo } from "../../../redux/slices/surveyInfo";

const useSurvey = () => {
  const [surveyList, setSurveyList] = useState(undefined);
  const [surveyStatistic, setSurveyStatistic] = useState(undefined);
  const [questionTypes, setQuestionTypes] = useState(undefined);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const id_user = user.info.id;

  const getSurveyList = async (data) => {
    const res = await getSurveyListService(data);
    if (res.success) {
      return setSurveyList(res.data?.response);
    }
    handleMessages(res);
  };

  const onSurveyOperation = async ({ operation, id_survey }) => {
    const functionToExecute = {
      duplicate: duplicateSurveyService,
      pause: pauseSurveyService,
      delete: deleteSurveyService,
      resume: resumeSurveyService,
    }[operation];

    const res = await functionToExecute({
      id_survey,
      id_user: user.info.id,
    });
    return handleMessages(res);
  };

  const createNewSurvey = async (username, surveyType) => {
    const res = await createNewSurveyService(username, surveyType);
    return res.data?.response;
  };

  const getSurveyInfo = async (id_survey) => {
    const res = await getSurveyInfoService(id_survey);
    if (res.success) {
      dispatch(setSurveyInfo(res.data?.response));
    }
    handleMessages(res);
  };

  const getSurveyStatistics = async (data) => {
    const res = await getSurveyStatisticsService(data);
    if (res.success) {
      return setSurveyStatistic(res.data?.response);
    }
    handleMessages(res);
  };

  const saveInitialSurveyInfo = async (data) => {
    const res = await saveInitialInfoService(data);
    if (!res.success) {
      handleMessages(res);
    }
  };

  const saveFinishSurveyInfo = async (data) => {
    const res = await saveFinishInfoService(data);
    if (!res.success) {
      handleMessages(res);
    }
  };

  const deleteSurveyPage = async (id_page) => {
    const res = await deleteSurveyPageService(id_page);
    return handleMessages(res);
  };

  const createNewSurveyPage = async (id_survey) => {
    const res = await createNewSurveyPageService(id_survey);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const saveSurveyDuration = async (data) => {
    const res = await saveSurveyDurationService(data);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const changeSwitchDuration = async (id_survey) => {
    const res = await changeSwitchDurationService(id_survey);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const getQuestionTypes = async () => {
    const res = await getQuestionTypesService();
    if (res.success) {
      return setQuestionTypes(res.data?.response);
    }
    handleMessages(res);
  };

  const createNewQuestion = async (data) => {
    const res = await createNewQuestionService({ ...data, id_user });
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const createNewQuestionOption = async (id_survey_question) => {
    const res = await createNewQuestionOptionService(id_survey_question);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const updateSurveyQuestion = async (data) => {
    const res = await updateSurveyQuestionService(data);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const deleteSurveyOption = async (id_question_option) => {
    const res = await deleteSurveyOptionService(id_question_option);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const updateSurveyOption = async (data) => {
    const res = await updateSurveyOptionService(data);
    if (!res.success) {
      handleMessages(res);
    }
    return res.success;
  };

  const deleteSurveyQuestion = async (id_survey_question) => {
    const res = await deleteQuestionService(id_survey_question);
    return handleMessages(res);
  };

  const duplicateSurveyQuestion = async (id_survey_question) => {
    const res = await duplicateQuestionService({ id_survey_question, id_user });
    return handleMessages(res);
  };

  const saveImageSurvey = async (data) => {
    const res = await saveImageSurveyService(data);
    return handleMessages(res);
  };

  const publishSurvey = async (id_survey) => {
    const res = await publishSurveyService(id_survey);
    return handleMessages(res);
  };

  const getSurveyExcel = async (id_survey) => {
    const res = await getSurveyExcelService(id_survey)
    return res.data
  }

  return {
    surveyList,
    getSurveyList,
    onSurveyOperation,
    createNewSurvey,
    getSurveyInfo,
    surveyStatistic,
    getSurveyStatistics,
    saveInitialSurveyInfo,
    deleteSurveyPage,
    createNewSurveyPage,
    saveSurveyDuration,
    changeSwitchDuration,
    questionTypes,
    getQuestionTypes,
    createNewQuestion,
    createNewQuestionOption,
    updateSurveyQuestion,
    deleteSurveyOption,
    updateSurveyOption,
    deleteSurveyQuestion,
    duplicateSurveyQuestion,
    saveFinishSurveyInfo,
    saveImageSurvey,
    publishSurvey,
    getSurveyExcel
  };
};

export default useSurvey;
